module.exports = __webpack_public_path__ + "static/img/homeImg.d652368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeImg.png
// module id = lPSV
// module chunks = 0